<template>
  <div>
    <!-- <Tabs :animated="false" type="card" @on-click="questionClick">
    
      <TabPane :label="$t('Q&A')">
        <QAView ref="MyQuestions"></QAView>
      </TabPane>
      <TabPane :label="$t('Continuous_Dialogues')">
        <ContinuousCommunicationVue
          ref="ContinuousCommunicationVue"
        ></ContinuousCommunicationVue>
      </TabPane>
    </Tabs> -->
    <!-- 持续沟通 -->
    <ContinuousCommunicationVue
          ref="ContinuousCommunicationVue"
    ></ContinuousCommunicationVue>
    <Spin size="large" fix v-if="loading"> </Spin>
  </div>
</template>

<script>
// import QuestionsList from "./QAComponents/QuestionsList";
// import QuestionPut from "./QAComponents/QuestionPut";
// import MyQuestions from "./QAComponents/MyQuestions";
import ContinuousCommunicationVue from "./QAComponents/ContinuousCommunication.vue";
import QAView from "./QAComponents/QAView.vue";
export default {
  components: {
    // QuestionsList,
    // QuestionPut,
    // MyQuestions,
    ContinuousCommunicationVue,
    QAView
  },
  data() {
    return {
      loading: false
    };
  },
  methods: {
    questionClick(val) {
      // if (val == 0) {
      //   this.$refs.QuestionsList.getData();
      // } else if (val == 2) {
      //   this.$refs.MyQuestions.getData();
      //   this.$refs.MyQuestions.$refs.ReplyQuestions.getData();
      // }
    }
  },
};
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/process/MyQuery/QaListInfo.vue